import { useModal } from "../../../customHooks/useModal";
import Modal from "../../Organisms/Modal/Modal";
import iconModalCreationMasive from '../../../assets/feather-users.svg'
import Button from "../../Atoms/Button/Button";
import { Table, Form, Checkbox, Select } from "antd";
import { useState } from "react";
import InputFormContainer from "../../Atoms/InputFormContainer/InputFormContainer";
import { useLocation } from "wouter";

const ModalImportMasive = ({ isOpenModal, closeModal, columnsTableUserList, usersListToImport }) => {
  const [, setLocation ] = useLocation();
  const [form] = Form.useForm();
  const [isOpenModalImportationSuccess, openModalImportationSuccess, closeModalImportationSuccess] = useModal(false)
  const [isOpenModalAssignRoles, openModalAssignRoles, closeModalAssignRoles] = useModal(false)
  const [isOpenModalAssignSuccess, openModalAssignSuccess, closeModalAssignSuccess] = useModal(false)
  const [listUsersImports, setListUsersImports] = useState([])
  const [listRolesAssign, setListtRolesAssign] = useState([])

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setListUsersImports(selectedRowKeys)
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
  };


  // Abre el modal para la selección de personas a importar
  const handleModalImportationSuccess = () => {
    closeModal()
    openModalImportationSuccess()
  }

  // Abre el modal para confirmar permisos de asignar roles a la lista importada.
  const handleModalAssignRoles = () => {
    closeModalImportationSuccess()
    openModalAssignRoles()
  } 

  // Formulario de importacion masiva
  const sendFormImportMasive = (e) => {
    console.log(e) // Información del from.
    setListtRolesAssign(e.type_of_roles)
    closeModalAssignRoles()
    openModalAssignSuccess() 
  }


  // Finalizar importación
  const finishImportation = () => {
    closeModalAssignSuccess();
    setLocation('/perfiles-roles/gestionar')
  }

  return (
    <div>
        {/* Modal para la Creación masiva */}
        <Modal
        isOpenModal={isOpenModal}
        closeModal={closeModal}
        iconModal={iconModalCreationMasive}
        titleModal="Creación masiva" 
        subTitleModal="Puedes crear perfiles y asignar roles a través de la importación de contactos vía archivo CSV hasta un máximo de 100."
      >
        <div className="buttons-container center">
          <Button content="Cargar archivo CSV" customClass="s-large m-auto" type="primary" clickHandler={() => handleModalImportationSuccess()}/>
        </div>
        <p className="source-16 mt-20">¿Tienes dudas? <span className="link">Descarga el ejemplo</span></p>
      </Modal>

      {/* Modal Importación exitosa */}
      <Modal
        isOpenModal={isOpenModalImportationSuccess}
        closeModal={closeModalImportationSuccess}
        iconModal={iconModalCreationMasive}
        titleModal="Importación exitosa" 
        subTitleModal="Has importado exitosamente la lista de contactos, a continuación te presentamos los datos, solo debes asignar uno o mas roles a la lista."
      >

      <div className="table-container">
        <Table
          rowSelection={{
            type: 'checkbox',
            ...rowSelection,
          }}
          columns={columnsTableUserList}
          dataSource={usersListToImport}
          pagination={false}
        />
      </div>
        <div className="buttons-container center">
          <Button content="Asignar Roles" customClass="s-large m-auto" type="primary" clickHandler={() => handleModalAssignRoles()}/>
        </div>
      </Modal>

      {/* Modal para aignar roles */}
      <Modal
        isOpenModal={isOpenModalAssignRoles}
        closeModal={closeModalAssignRoles}
        iconModal={iconModalCreationMasive}
        titleModal="Asigna roles" 
        subTitleModal="Una vez seleccionado los contactos asigna uno o mas roles para esta lista."
      >
        <div>
          <p className="source-20 bold mt-20 text-letf mb-20 ">Total de contactos importados: {listUsersImports.length}</p>
        </div>
        
        <Form onFinish={sendFormImportMasive} form={form} >
          <InputFormContainer spanTwo label="Tipo de rol (puedes asignar más de uno):" indentificador="type">
            <Form.Item
              name="type_of_roles"
              rules={[{ required: true, message: "Por favor ingrese Tipo de rol" }]}
            >
              <Select placeholder="Tipo de rol" mode="multiple" size="large">
                <Select.Option value="Administrativo" key={1}>
                  Administrativo
                </Select.Option>
                <Select.Option value="Funcional" key={2}>
                  Funcional
                </Select.Option>
                <Select.Option value="Agente" key={3}>
                  Agente
                </Select.Option>
              </Select>
            </Form.Item>
          </InputFormContainer>

          <Form.Item name="permits" valuePropName="checked" className="text-letf" rules={[{ required: true, message: "Por favor acepte los permiso " }]}>
            <Checkbox>Confirmo que tengo permiso de asignar roles a la lista importada.</Checkbox>
          </Form.Item>

          <div className="buttons-container center">
            <Button  htmlType="submit" content="Finalizar importación" customClass="s-large m-auto" type="primary" />
          </div>
        </Form>
      </Modal>
      
      {/* Modal para indicar que la importación e asignación a exitosa */}
      <Modal
        isOpenModal={isOpenModalAssignSuccess}
        closeModal={closeModalAssignSuccess}
        iconModal={iconModalCreationMasive}
        titleModal="¡Listo!" 
        subTitleModal="Haz importado y asignado roles correctamente a la lista."
      >

        <p className="source-16 bold mt-20  mb-20 ">Total de contactos importados: {listUsersImports.length}</p>
        <p className="source-16 bold mb-20 ">Roles asignados: {listRolesAssign.map(rol => <span className="mr-5">{rol}</span>)}</p>
        <div className="buttons-container center">
          <Button content="Ir a perfiles y roles" customClass="s-large m-auto" type="primary" clickHandler={() => finishImportation()}/>
        </div>
       
      </Modal>
    </div>
  )
}

export default ModalImportMasive

